pt({ "en": { "cmsf-branding": { "buttonLabel": "Built on HubSpot", "dropdown": { "reportAbuse": "Report Abuse", "getCms": "Create your own free website" } } } });
export var translations;
function pt(t) { (translations = translations || []).push(t); }

